<template>
    <div>
        <loading v-if="fetchingReasons" class="mb-16"></loading>
        <template v-else>
            <label v-if=hasExternalPartner
                   class="mb-8 text-body-sm flex items-center">
                <span class="first-letter:uppercase">{{ $t('applications.reject_reason_internal') }}</span>
            </label>
            <select-dropdown
                v-if="reasons.length"
                v-model="reason"
                :options="reasons"
                no-auto-sort
                :auto-translate="false"
                :placeholder="$t('applications.reject_reason_placeholder')"
                class="mb-8"
            />
            <text-area v-model="comment" :class="{'mb-16': !hasExternalPartner}" :placeholder="$t('applications.reject_comment_placeholder')"/>

            <text-area v-if=hasExternalPartner
                       v-model="comment_external"
                       :placeholder="$t('applications.reject_comment_external_placeholder')"
                       class="mt-8 mb-16">
                {{ $t('applications.reject_reason_external') }}
            </text-area>
        </template>
    </div>
</template>

<script>
import SelectDropdown from '../forms/SelectDropdown';
import TextArea from '../forms/TextArea';
import * as RejectedReasonService from '../../services/RejectReasonService';
import RejectReason from '../../models/RejectReason';
import {normalizeJson} from '../../../shared/helpers';
import Loading from './Loading';
import {useRepo} from "pinia-orm";

export default {
    components: {Loading, TextArea, SelectDropdown},
    props: {
        value: Object,
        hasExternalPartner: Boolean,
    },
    data() {
        return {
            fetchingReasons: false,
        };
    },
    computed: {
        reason: {
            get() {
                return this.value.reason;
            },
            set(val) {
                return this.update('reason', val);
            },
        },
        comment: {
            get() {
                return this.value.comment;
            },
            set(val) {
                return this.update('comment', val);
            },
        },
        comment_external: {
            get() {
                return this.value.comment_external;
            },
            set(val) {
                return this.update('comment_external', val);
            },
        },
        reasons() {
            return useRepo(RejectReason).orderBy('order').get()
                .map(item => ({
                    label: item.title,
                    value: item.title,
                }));
        },
    },
    methods: {
        update(key, val) {
            let obj = this.value;
            obj[key] = val;
            this.$emit('input', obj);
            return obj;
        },
        fetchReasons() {
            return RejectedReasonService.index().then(({data}) => {
                return useRepo(RejectReason).save(normalizeJson(data));
            });
        },
    },
    mounted() {
        this.fetchingReasons = true;
        this.fetchReasons().then(() => this.fetchingReasons = false);
    },
};
</script>
